import React from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { Notification } from '@offerzen/pinata-shame'

import styles from './styles'

const Toast = ({ theme, message, icon, onDismiss }) => {
  if (!message) return null

  return createPortal(
    <Notification className={styles.wrapper} icon={icon} theme={theme} onDismiss={onDismiss}>
      <div className={styles.text} role="alert">
        {message}
      </div>
    </Notification>,
    document.getElementById('react-toast'),
  )
}

Toast.propTypes = {
  theme: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.string,
  onDismiss: PropTypes.func,
}

export default Toast
